import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import TimerIcon from '@mui/icons-material/Timer';

const SubModule = ({ 
  title, 
  description, 
  lessons = [], // Add default empty array for lessons
  onStartLesson,
  completedLessons = new Set() // Add default empty Set for completedLessons
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>
      <List>
        {lessons.map((lesson) => (
          <ListItem
            key={lesson.id}
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              mb: 1,
              p: 2
            }}
          >
            <ListItemIcon>
              {completedLessons.has(lesson.id) ? (
                <CheckCircleIcon color="success" />
              ) : (
                <PlayCircleOutlineIcon color="primary" />
              )}
            </ListItemIcon>
            <ListItemText
              primary={lesson.title}
              secondary={
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                  <TimerIcon sx={{ fontSize: 16, mr: 0.5, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    {lesson.duration} minutes
                  </Typography>
                </Box>
              }
            />
            <Button
              variant={completedLessons.has(lesson.id) ? "outlined" : "contained"}
              color={completedLessons.has(lesson.id) ? "success" : "primary"}
              onClick={() => onStartLesson(lesson)}
              sx={{ ml: 2 }}
            >
              {completedLessons.has(lesson.id) ? "Review" : "Start"}
            </Button>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default SubModule;
